import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';
import styles from './index.css';

const ItemAd = ({ content }) => {

    return (
        content && <div className={styles.item}>
            <div className={styles.left}>
                <div className={styles.line} />
            </div>
            <div className={styles.content}>
                <Ad content={content} />
            </div>
        </div>
    );
};

ItemAd.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(ItemAd);
